import React , {Component} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash'

import { Page } from 'schema'
import { Button, TextField, Paper, Icon } from 'components'
import { IconInput } from 'features'

import * as actionCreators from 'store/actions'

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${props => props.inline ? '0' : '0.5rem'};
    background-color: var(--secondary-color);
    border-radius: 5px;
`

class PageInput extends Component {
    constructor(props){
        super(props);
        this.state = {
            page: this.props.page || new Page({createdBy: this.props.uid}),
            error: '',
            valid: this.props.page ? true : false,
        }
    }

    static getDerivedStateFromProps(props, state) {
        if(props.page && !_.isEqual(props.page.icon, state.page.icon)){
            state.page = props.page
        }
        return state
    }

    onInputHandler = (event) => {
        let updatedPage = {...this.state.page}
        updatedPage['page_name'] = event.target.value
        this.setState({
            page: updatedPage,
            valid: event.target.value.length > 0 ? true : false,
            error: event.target.value.length > 0 ? null : '*Please give a name'
        })
    }

    onKeyPressHandler = (event) => {
        if (event.charCode === 13) {
            if(this.state.valid){
                this.onSubmitHandler();
            }
            
        } 
    }

    onKeyDownHandler = (event) => {
        if (event.keyCode === 27 ) {
            this.props.closeHandler()
        }
    }

    onSubmitHandler = () => {
        if(this.props.page){
            this.props.updatePage(this.state.page, this.props.data, this.props.uid, this.props.sessionId)
        } else {
            // console.log({page: this.state.page, uid: this.props.uid})
            let updatedPage = (({ pageID, ...o }) => o)(this.state.page)
            this.props.createPage(updatedPage, this.props.data, this.props.user, this.props.sessionId)
        }   
        this.props.closeHandler && this.props.closeHandler()
        this.props.closeHandler2 && this.props.closeHandler2()
    }

    onSelectIconHandler = (value, type) => {
        const updatedPage = {...this.props.page}
        updatedPage['icon'] = {value: value, type: type}
        this.props.updatePage(updatedPage, this.props.data, this.props.uid, this.props.sessionId)
    }

    render() {
        return (
            this.props.inline ?
            <Container inline={this.props.inline}>
                <div></div>
                <Icon size='1rem' iconInput={<IconInput/>} onSubmit={this.onSelectIconHandler}
                    styles={{backgroundColor: 'var(--secondary-color)', margin: '0 0rem 0 0'}}
                    value={this.state.page.icon && this.state.page.icon.value} type={this.state.page.icon && this.state.page.icon.type}/>
                <TextField type='single' 
                    placeholder={this.props.page ? 'Update page' : 'Name this page'}
                    value={this.state.page.page_name} 
                    onChange={this.onInputHandler}
                    onKeyPress={this.onKeyPressHandler} 
                    onKeyDown={this.onKeyDownHandler}/>
                <Button text={this.props.page ? 'Update' : 'Create'} styles={{backgroundColor:'var(--focus-color)', color: 'white', margin:'0 0 0 0.5rem'}}
                    disabled={!this.state.valid}
                    onSelect={this.onSubmitHandler}/>
            </Container>
            : 
            <Paper backgroundColor='var(--secondary-color)'>
                <Container>
                    <TextField type='single' focus
                        placeholder={this.props.page ? 'Update page' : 'Name this page'}
                        value={this.state.page.page_name} 
                        onChange={this.onInputHandler}
                        onKeyPress={this.onKeyPressHandler} 
                        onKeyDown={this.onKeyDownHandler}/>
                    <Button text={this.props.page ? 'Update' : 'Create'} styles={{backgroundColor:'var(--focus-color)', color: 'white', margin:'0 0 0 0.5rem'}}
                        disabled={!this.state.valid}
                        onSelect={this.onSubmitHandler}/>
                </Container>
            </Paper>
            
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        sessionId: state.content.sessionId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createPage: (page, data, user, sessionId) => dispatch(actionCreators.createPage(page, data, user, sessionId)),
        updatePage: (page, data, userId, sessionId) => dispatch(actionCreators.updatePage(page, data, userId, sessionId))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( PageInput );


PageInput.propTypes = {
    page: PropTypes.instanceOf(Page),
    type: PropTypes.oneOf(['Input','Edit']),
    inline: PropTypes.bool
};